export default __webpack_public_path__ + "static/media/rizin.99dfee89.jpg";